import { keyframes } from "styled-components";

export const pulse = keyframes`
  0% {
    opacity: 0;
  }

  65% {
    opacity: 0.3;
  }

  100% {
    opacity: 0;
  }
`;

export const pulse2 = keyframes`
  0% {
    opacity: 0;
  }

  40% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
  }
`;

export const handPulse = keyframes`
  0% {
    transform: translateX(-50%) translateY(-52%) rotate3d(1, 0.5, 0, 3deg);
  }

  60% {
    transform: translateX(-50%) translateY(-50%) rotate3d(1, 0, 0, 0);
  }

  100% {
    transform: translateX(-50%) translateY(-52%) rotate3d(1, 0.5, 0, 3deg);
  }
`;

export const bottlePulse = keyframes`
  0% {
    transform: translateX(-51%) translateY(-93.25%);
  }

  60% {
    transform: translateX(-51%) translateY(-89.25%);
  }

  100% {
    transform: translateX(-51%) translateY(-93.25%);
  }
`;
